import React from 'react';

/**
 * Profile Page Component
 *
 * TODO: Implement user profile view and edit
 */
const ProfilePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Profile</h1>
        <div className="card p-6">
          <p className="text-gray-600">Profile page - Coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
